/** scoreRanking.hooks */

import { PageRequest, PageResponse } from '@/interface/index.interface';
import { cloneDeep } from '@/lib';
import scoreRankingServices from '@/services/scoreRanking.services';
import { definitions } from '@/types/api';

const columns = [
  // { title: '案例名称', dataIndex: 'caseName' },
  { title: '实验名称', dataIndex: 'experimentName' },
  { title: '实训模式', dataIndex: 'experimentModel', slots: { customRender: 'experimentModel' } },
  { title: '开始时间', dataIndex: 'beginTime' },
  { title: '结束时间', dataIndex: 'endTime' },
  { title: '实训模块', dataIndex: 'caseModule', slots: { customRender: 'caseModule' } },
  { title: '实验状态', dataIndex: 'status', slots: { customRender: 'status' } },
  { title: '得分', dataIndex: 'experimentScore', slots: { customRender: 'experimentScore' } },
  { title: '排名', dataIndex: 'experimentRank', slots: { customRender: 'experimentRank' } },
  { title: '操作', dataIndex: 'action', slots: { customRender: 'action' } },
];
/** 列表 */
export interface TableData {
  tableLoading: boolean;
  tableList: definitions['Experiment'][];
  columns: typeof columns;
}

/** 成绩排名 hooks */
const useScoreRankingHooks = () => {
  const { listExperimentApi } = scoreRankingServices();
  /** 获取成绩排名列表 */
  const listExperimentRanking = async (param: PageRequest<{}>): Promise<PageResponse<definitions['ExperimentScoreResponse']>> => {
    const { list, totalRecords } = await listExperimentApi(param);
    return {
      list,
      total: totalRecords || 0,
    };
  };

  /** 学生端-获得成绩排名-table列 */
  const stuScoreRankingColumns = () => (cloneDeep(columns));

  return {
    listExperimentRanking,
    stuScoreRankingColumns,
  };
};

export default useScoreRankingHooks;
